import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function ShippingPolicy() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">SHIPPING & DELIVERY POLICY</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li className="mb-3"><strong>Delivery Timeline:</strong> All products are delivered within 1 hour.</li>
                  <li className="mb-3"><strong>Store Pickup (Primary):</strong> Adcaster operates primarily on a self-pickup and self-return model at our Kottakkal store to ensure physical equipment inspection and document verification.</li>
                  <li className="mb-3"><strong>Local Delivery Services:</strong> If doorstep delivery or courier shipping is requested and agreed upon, delivery charges will be borne entirely by the customer.</li>
                  <li className="mb-3"><strong>Inspection Upon Delivery:</strong> For delivered items, the customer must inspect the equipment immediately upon receipt and report any physical damages or operational issues within 1 hour of delivery.</li>
                  <li className="mb-3"><strong>Return Shipping:</strong> For shipped rentals, return transit time must be factored into the rental duration, and equipment must be safely packed and shipped back via trusted courier services at the renter's expense.</li>
                </ul>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
